// removed by extract-text-webpack-plugin
module.exports = {"outer-wrapper":"gam0Se32tU0G1ukX4UAs4","outerWrapper":"gam0Se32tU0G1ukX4UAs4","wrapper":"_2E48CcxSf4qPDMA5FX_-e5","container":"_2bi9wJ_ZTCZnV5u4Z9WczR","column":"_1nnH5hzLh61jbGnTcLr_ee","header-column":"_3-nvBeVmI9S-T7gWhLToSN","headerColumn":"_3-nvBeVmI9S-T7gWhLToSN","company":"Dme8dY0EQAlr2aabXVk5Y","subtitle":"PQtgPvDoRR2wAqsEDZO4w","title":"_1akW1RpqNuE-znPRgtSsQZ"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Header/styles.scss
 ** module id = 414
 ** module chunks = 0
 **/